export const contactEmailConstants = {
  HR: "hr@firestormfire.com",
  JIMMY_DO: "jimmy@firestormfire.com",
  TEST_ADMIN: "wrg_test_admin@mailinator.com",
};
